(function () {
  'use strict';

  window.scroll(0, 0);

  String.prototype.isValidEmail = function () {
    return /^[a-z0-9.]+@[a-z0-9]+\.[a-z]+(\.([a-z]+))?$/i.test(this);
  };

  function formatPhoneNumber(e) {
    var x = e.target.value
      .replace('+55', '')
      .replace(/\D/g, '')
      .match(/(\d{0,2})(\d{0,5})(\d{0,4})/);
    e.target.value = !x[1] ? x[0] : '+55 (' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
  }

  function spinner() {
    return '<div class="spinner__wrapper"><span class="spinner"></span></div>';
  }

  function parseHTML(str) {
    const parser = new DOMParser();

    return parser.parseFromString(str, 'text/html');
  }

  function formatMoney(money) {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(money);
  }

  function insiderSendQuizForm({ email, phone }, ids, attribute = null) {
    try {
      if (!Array.isArray(ids)) throw new Error('The argument "ids" must be an array.');

      window.insider_object = window.insider_object || {};

      window.insider_object.user = {
        email: email,
        phone_number: phone,
        language: 'pt-br',
        gdpr_optin: true,
        email_optin: true,
        list_id: ids,
        custom: attribute,
      };

      Insider.eventManager.dispatch('init-manager:re-initialize');
    } catch (err) {
      console.error(err);
    }
  }

  async function getProduct(handle, type = 'text', args = '') {
    if (type === 'text') {
      const strHtml = await fetch(`/products/${handle}${args}`).then((r) => r.text());
      const doc = parseHTML(strHtml);

      return doc.querySelector('product-card');
    }

    return await fetch(`/products/${handle}.js`, {
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((r) => r.json());
  }

  function calculateWinnerResult(points, quizResultsOptions = {}) {
    const [first, second] = Object.keys(points).sort((key1, key2) => {
      const v1 = points[key1];
      const v2 = points[key2];

      if (v1 > v2) return -1;
      else if (v1 < v2) return 1;

      return 0;
    });

    const selectedResult = quizResultsOptions.find(({ type, type_2 }) => type === first && type_2 === second);

    console.info('Result Main: ', first);
    console.info('Result Support: ', second);
    console.info('Result data: ', selectedResult);
    console.info('Result summary: ', points);

    selectedResult.points = {
      [first]: points[first],
      [second]: points[second],
    };

    return selectedResult;
  }

  try {
    class QuizContainer extends HTMLElement {
      constructor() {
        super();

        this.currentSlide = 1;
        this.slides = document.querySelectorAll('.quiz-question--section');
        this.slideCount = this.slides.length + 1;
        this.style.setProperty('--slide-count', (this.slideCount || 0) + 2);

        window.scroll(0, 0);

        this.points = {
          nutrition: 0,
          hidratation: 0,
          reconstruction: 0,
          multifuncional: 0,
          antifrizz: 0,
          cachos: 0,
        };

        this._resizeContainer(0);
      }

      connectedCallback() {
        this.querySelectorAll(
          '.quiz-question__answer-input[type="radio"], .quiz-question__answer-input--no-alternative'
        ).forEach((btn) => {
          btn.addEventListener('change', this._next.bind(this));
        });
        this.querySelectorAll('.quiz-question__answer-input[type="checkbox"]').forEach((btn) => {
          btn.addEventListener('change', this._hideInfoTitle.bind(this));
        });

        this.querySelectorAll('[data-next]').forEach((btn) => {
          btn.addEventListener('click', this._next.bind(this));
        });

        this.querySelectorAll('[data-previous]').forEach((btn) => {
          btn.addEventListener('click', this._previous.bind(this));
        });
      }

      _next(e) {
        e.preventDefault();

        this.currentSlide = Math.min(this.slideCount, this.currentSlide + 1);
        this.style.setProperty('--current-slide', this.currentSlide);

        // window.scroll(0, 0);

        this.acumuledPoints();
        this._changeSlide(this.currentSlide, 'next');
      }

      _previous(e) {
        e.preventDefault();

        const slide = this.children.item(this.currentSlide);

        slide.querySelectorAll('input').forEach((input) => {
          input.checked = false;
        });

        this.currentSlide = Math.max(0, this.currentSlide - 1);
        this.style.setProperty('--current-slide', this.currentSlide);

        // window.scroll(0, 0);

        this.acumuledPoints();
        this._changeSlide(this.currentSlide, 'previous');
      }

      _hideInfoTitle(e) {
        e.preventDefault();

        const question = e.target.closest('.quiz-question');
        const checkedAnswers = question.querySelectorAll('input:checked').length;
        const infoTitle = question.querySelector('.quiz-question__info');

        if (checkedAnswers > 0) {
          infoTitle.style.opacity = 0;
        } else {
          infoTitle.style.opacity = 1;
        }
      }

      acumuledPoints() {
        const points = {
          nutrition: 0,
          hidratation: 0,
          reconstruction: 0,
          multifuncional: 0,
          antifrizz: 0,
          cachos: 0,
        };

        this.querySelectorAll('.quiz-question__answer-input:checked').forEach((opt) => {
          points.nutrition += parseInt(opt.dataset.nutrition);
          points.hidratation += parseInt(opt.dataset.hidratation);
          points.reconstruction += parseInt(opt.dataset.reconstruction);
          points.multifuncional += parseInt(opt.dataset.multifuncional);
          points.antifrizz += parseInt(opt.dataset.antifrizz);
          points.cachos += parseInt(opt.dataset.cachos);
        });

        this.points = points;
      }

      _resizeContainer(slideIndex) {
        try {
          const slide = this.slides[Math.max(0, slideIndex - 1)];
          const section = slide?.querySelector('.section');

          if (section) {
            this.style.height = `${Math.max(section.offsetHeight, 900)}px`;
          }
        } catch (err) {
          console.error(err);
        }
      }

      _changeSlide(slideIndex, action) {
        this._resizeContainer(slideIndex || 0);

        document.dispatchEvent(
          new CustomEvent('slide:change', {
            bubbles: true,
            detail: {
              slideIndex,
              action: 'action:' + action,
              points: this.points,
            },
          })
        );
      }
    }
    if (!window.customElements.get('quiz-container')) {
      window.customElements.define('quiz-container', QuizContainer);
    }

    class QuizProgress extends HTMLElement {
      constructor() {
        super();

        this.quizContainer = document.querySelector('quiz-container');
        this.stepsCount = Math.max(0, parseInt(this.quizContainer.style.getPropertyValue('--slide-count') || 0) - 2);
      }

      connectedCallback() {
        for (let i = 0, j = this.stepsCount; i < j; i++) {
          const HTMLSpan = document.createElement('span');

          this.appendChild(HTMLSpan);
        }

        document.addEventListener('slide:change', this._update.bind(this));

        document.dispatchEvent(
          new CustomEvent('slide:change', {
            bubbles: true,
            detail: {
              slideIndex: 1,
            },
          })
        );
      }

      _update(e) {
        e.preventDefault();
        e.stopPropagation();

        const steps = this.children;
        const slideIndex = e.detail.slideIndex;

        for (let i = 1, j = steps.length + 1; i < j; i++) {
          const step = steps.item(i - 1);

          if (i < slideIndex) {
            step.classList.add('completed');
            step.classList.remove('current');
          } else if (i == slideIndex) {
            step.classList.add('current');
          } else {
            step.classList.remove('completed', 'current');
          }
        }

        if (slideIndex === 0 || slideIndex === document.querySelector('quiz-container').children.length - 1) {
          this.style.opacity = 0;
        } else {
          this.style.opacity = 1;
        }
      }
    }
    if (!window.customElements.get('quiz-progress')) {
      window.customElements.define('quiz-progress', QuizProgress);
    }

    class QuizAnswer extends HTMLElement {
      constructor() {
        super();

        this.inputs = Array.from(this.querySelectorAll('[pattern][data-validate]'));
      }

      connectedCallback() {
        const emailInput = this.querySelector('#quiz-question-email');
        const phoneInput = this.querySelector('#quiz-question-phone-number');

        if (emailInput !== null) {
          emailInput.addEventListener('keyup', this._validEmail.bind(this));
        }

        if (phoneInput !== null) {
          phoneInput.addEventListener('keyup', this._validPhone.bind(this));
        }

        this.inputs.forEach((input) => {
          input.addEventListener('keyup', this._validate.bind(this));
        });
      }

      _validate(e) {
        e.preventDefault();

        try {
          const input = e.target;
          const pattern = input.getAttribute('pattern');
          const re = new RegExp(`${pattern}`);
          const button = this.querySelector(input.dataset.validate);

          button.disabled = !re.test(input.value);
        } catch (err) {
          console.error(err);
        }
      }

      _validEmail(e) {
        e.preventDefault();

        const button = this.querySelector('#quiz-question-view-result');
        const phoneInput = this.querySelector('#quiz-question-phone-number');

        if (button !== null) {
          if (e.currentTarget.value.isValidEmail()) {
            button.disabled = false;
          } else {
            button.disabled = true;
          }
        }
      }
      _validPhone(e) {
        formatPhoneNumber(e);

        const button = this.querySelector('#quiz-question-view-result');
        const emailInput = this.querySelector('#quiz-question-email');

        if (button !== null) {
          if (e.currentTarget.value.length === 19) {
            button.disabled = false;
          } else {
            button.disabled = true;
          }
        }
      }
    }
    if (!window.customElements.get('quiz-answer')) {
      window.customElements.define('quiz-answer', QuizAnswer);
    }

    class QuizAnswersList extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {}
    }
    if (!window.customElements.get('quiz-answers-list')) {
      window.customElements.define('quiz-answers-list', QuizAnswersList);
    }

    class QuizResults extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        document.addEventListener('slide:change', this._render.bind(this));
      }

      async _render(e) {
        e.preventDefault();
        e.stopPropagation();

        const data = e.detail;

        if (data.slideIndex == document.querySelector('quiz-container').children.length - 1) {
          const quizQuestionEmail = document.querySelector('#quiz-question-email');
          const quizQuestionPhone = document.querySelector('#quiz-question-phone-number');

          if (quizQuestionEmail !== null && quizQuestionPhone !== null) {
            const listID = document.querySelector('#quiz-question-list-id').value;

            if (listID !== null && typeof insiderSendQuizForm === 'function') {
              const points = {
                nutrition: 0,
                hidratation: 0,
                reconstruction: 0,
                multifuncional: 0,
                antifrizz: 0,
                cachos: 0,
              };
              const result = {
                type: '',
                points: 0,
                data: null,
              };
              const inputText = document.querySelector('[name="question_answer_text"]');

              document.querySelectorAll('.quiz-question__answer-input:checked').forEach((opt) => {
                points.nutrition += parseInt(opt.dataset.nutrition);
                points.hidratation += parseInt(opt.dataset.hidratation);
                points.reconstruction += parseInt(opt.dataset.reconstruction);
                points.multifuncional += parseInt(opt.dataset.multifuncional);
                points.antifrizz += parseInt(opt.dataset.antifrizz);
                points.cachos += parseInt(opt.dataset.cachos);
              });

              for (let type in points) {
                if (points[type] > result.points) {
                  result.points = points[type];
                  result.type = type;
                  result.data = quizResultsOptions.find((i) => i.type == type);
                }
              }

              const quizResult = {
                quiz_result_points: result.points,
                quiz_result_type: result.type,
                quiz_text: inputText !== null ? inputText.value : '',
              };

              const attributes = {};

              document.querySelectorAll('[data-question]:checked').forEach((el) => {
                if (typeof attributes[el.dataset.question] === 'undefined') {
                  attributes[el.dataset.question] = [];
                }

                attributes[el.dataset.question].push(el.dataset.answer);
              });

              for (let attr in attributes) {
                quizResult[attr] = attributes[attr].join(',');
              }

              insiderSendQuizForm(
                {
                  email: quizQuestionEmail.value,
                  phone: quizQuestionPhone.value.replace(/[^0-9]/, ''),
                },
                [listID.value],
                quizResult
              );
            }
          }

          /* Request the winner products */
          if (typeof quizResultsOptions !== 'undefined') {
            const { points } = data;
            const result = calculateWinnerResult(points, quizResultsOptions);

            if (result !== null) {
              try {
                /*
                  const inputText = document.querySelector('[name="question_answer_text"]');
                  window.quizResult = {
                    quiz_result_points: result.points,
                    quiz_result_type: [result.type || '', result.type_2 || ''].filter((v) => v !== ''),
                    quiz_text: inputText !== null ? inputText.value : '',
                  };
                */

                /*
                 * Scroll to the top and resize the document content when change the quiz page
                 */
                const container = this.closest('.main__sections');
                if (container) {
                  container.style.height = 'auto';

                  // setTimeout(() => window.scrollTo(0, 0), 100);
                }
                /* ======= */

                /* Start: infographic */
                const quizInfographic = document.querySelector('#infographic-text');

                if (quizInfographic) {
                  quizInfographic.innerHTML = parseHTML(result.infographic_text).body.innerHTML;
                }
                /* End: infographic */

                /* Start: main product */
                const mainProductsData = [];

                if (result.main_products.length > 0) {
                  for (let i = 0, j = result.main_products.length; i < j; i++) {
                    const handle = result.main_products[i].handle;
                    const response = await getProduct(
                      handle.replace(/\/?products\/?/gi, ''),
                      'text',
                      '?section_id=quiz-card-product'
                    );

                    mainProductsData.push(response.outerHTML);
                  }

                  const quizMainProductHtml = document.querySelector('#quiz-main-product');

                  if (quizMainProductHtml) {
                    const quizMainProductItemHtml = quizMainProductHtml.querySelector('[data-product]');
                    const quizMainProductDescriptionHtml = quizMainProductHtml.querySelector('[data-description]');

                    if (quizMainProductItemHtml && quizMainProductDescriptionHtml) {
                      quizMainProductItemHtml.innerHTML = mainProductsData.join('');
                      quizMainProductDescriptionHtml.innerHTML = result.main_product_description;

                      const ids = result.main_products.map((p) => p.variant_id);
                      quizMainProductDescriptionHtml.innerHTML += `
                        <div>
                          <div class="quiz-buttons__wrapper">
                            <button class="button button--primary button--xl" data-add data-variant="${ids.join(
                              ','
                            )}">COMPRAR AGORA</button>
                          </div>
                        </div>
                      `;
                    }

                    if (result.main_products.length > 1) {
                      const container = quizMainProductHtml.closest('.quiz-result__grid');

                      container.classList.add('quiz-result__grid--s' + result.main_products.length);

                      if (container) {
                        container.classList.add('flexbox');
                      }

                      const gridItemProduct = quizMainProductHtml.querySelector('[data-product]');
                      const gridItemDescription = quizMainProductHtml.querySelector('[data-description]');

                      if (gridItemProduct) {
                        gridItemProduct.classList.add('grid__item--multiple');
                      }

                      if (gridItemDescription) {
                        gridItemDescription.classList.add('text-center');
                      }
                    }
                  }
                }
                /* End: main product */

                /* Start: support product */
                const supportProductsData = [];

                if (result.support_products.length > 0) {
                  for (let i = 0, j = result.support_products.length; i < j; i++) {
                    const handle = result.support_products[i].handle;
                    const response = await getProduct(
                      handle.replace(/\/?products\/?/gi, ''),
                      'text',
                      '?section_id=quiz-card-product'
                    );

                    supportProductsData.push(response.outerHTML);
                  }

                  const quizSupportProductHtml = document.querySelector('#quiz-support-product');

                  if (quizSupportProductHtml) {
                    const quizSupportProductItemHtml = quizSupportProductHtml.querySelector('[data-product]');
                    const quizSupportProductDescriptionHtml =
                      quizSupportProductHtml.querySelector('[data-description]');

                    if (quizSupportProductItemHtml && quizSupportProductDescriptionHtml) {
                      quizSupportProductItemHtml.innerHTML = supportProductsData.join('');
                      quizSupportProductDescriptionHtml.innerHTML = result.support_product_description;

                      const ids = result.support_products.map((p) => p.variant_id);
                      quizSupportProductDescriptionHtml.innerHTML += `
                        <div>
                          <div class="quiz-buttons__wrapper">
                            <button class="button button--primary button--xl" data-add data-variant="${ids.join(
                              ','
                            )}">COMPRAR AGORA</button>
                          </div>
                        </div>
                      `;
                    }

                    if (result.support_products.length > 1) {
                      const container = quizSupportProductHtml.closest('.quiz-result__grid');

                      container.classList.add('quiz-result__grid--s' + result.support_products.length);

                      if (container) {
                        container.classList.replace('reverse', 'flexbox-reverse');
                      }

                      const gridItemProduct = quizSupportProductHtml.querySelector('[data-product]');
                      const gridItemDescription = quizSupportProductHtml.querySelector('[data-description]');

                      if (gridItemProduct) {
                        gridItemProduct.classList.add('grid__item--multiple');
                      }

                      if (gridItemDescription) {
                        gridItemDescription.classList.add('text-center');
                      }
                    }
                  }
                }
                /* End: support product */

                /* Start: combined products */
                const allProducts = [];

                for (let i = 0, j = result.main_products.length; i < j; i++) {
                  const handle = result.main_products[i].handle;

                  allProducts.push(await getProduct(handle.replace(/\/?products\/?/gi, ''), 'json'));
                }

                for (let i = 0, j = result.support_products.length; i < j; i++) {
                  const handle = result.support_products[i].handle;

                  allProducts.push(await getProduct(handle.replace(/\/?products\/?/gi, ''), 'json'));
                }

                if (allProducts.length > 0) {
                  const combinedContainerHtml = document.querySelector('#quiz-combined-products');

                  if (combinedContainerHtml) {
                    if (result.combined_image !== null) {
                      combinedContainerHtml.innerHTML = `<img src="${result.combined_image}" alt="Capa para as rotinas combinadas"/>`;
                    } else {
                      const contentList = allProducts
                        .map((p) => {
                          return `
                          <div class="quiz-result__combined-item text-center v-stack gap-3">
                            <img src="${p.featured_image}" alt="Capa para a rotina principal" class="rounded"/>
                            <div>
                              <h3 class="h5">${p.title}</h3>
                              <sale-price class="text-on-sale h5">${formatMoney(p.price / 100)}</sale-price>
                            </div>
                          </div>
                        `;
                        })
                        .join('');

                      combinedContainerHtml.innerHTML = contentList;
                    }

                    const combinedDescription = document.querySelector('#quiz-combined-description');

                    if (combinedDescription) {
                      combinedDescription.innerHTML = result.combined_description;
                    }
                  }

                  const combinedProductsButton = document.querySelector('#quiz-combined-button');

                  if (combinedProductsButton) {
                    const ids = `
                      ${result.main_products.map((p) => p.variant_id).join(',')},${result.support_products
                      .map((p) => p.variant_id)
                      .join(',')}
                    `;
                    combinedProductsButton.innerHTML = `
                      <div>
                        <div class="quiz-buttons__wrapper">
                          <button class="button button--primary button--xl" data-add data-variant="${ids}">QUERO UMA ROTINA COMPLETA</button>
                        </div>
                      </div>
                      `;
                  }
                }
                /* End: combined products */

                /* Start: use mode */
                const mainProductUseMode = document.querySelector('#quiz-main-product-use-mode');
                const supportProductUseMode = document.querySelector('#quiz-support-product-use-mode');
                const combinedProductsDescription = document.querySelector('#quiz-combined-product-description');

                if (mainProductUseMode) {
                  mainProductUseMode.innerHTML = result.main_product_use_mode;
                }

                if (supportProductUseMode) {
                  supportProductUseMode.innerHTML = result.support_product_use_mode;
                }

                if (combinedProductsDescription) {
                  combinedProductsDescription.innerHTML = result.combined_description;
                }
                /* End: use mode */

                /* Start: Events */
                document.querySelectorAll('.product-card__quick-buy').forEach((e) => e.remove());
                document.querySelectorAll('button[data-add]').forEach((button) => {
                  button.addEventListener('click', async (e) => {
                    const variants = button.dataset.variant.trim().split(',');
                    const payload = {
                      items: variants.map((variant_id) => ({
                        id: variant_id,
                        quantity: 1,
                        properties: {
                          _origin: window.location.pathname,
                        },
                      })),
                    };

                    button.disabled = true;
                    button.innerHTML = 'ADICIONANDO...';
                    await fetch('/cart/clear.js').then(async () => {
                      document.documentElement.classList.toggle('invisible');
                      await fetch('/cart/add.js', {
                        method: 'post',
                        headers: {
                          'Content-Type': 'application/json',
                        },
                        body: JSON.stringify(payload),
                      });
                      await fetch('/cart.json').then(() => {
                        setTimeout(() => {
                          window.location.pathname = '/checkout';
                        }, 800);
                      });
                    });

                    // window.location.href = `/checkout`;
                  });
                });
                /* End: Events */
              } catch (err) {
                console.error(err);
              }
            }
          }

          /** Render items */
          const pointsBar = this.querySelectorAll('.quiz-results__type-points');

          pointsBar.forEach((bar) => {
            const type = bar.dataset.type;
            const items = bar.querySelectorAll('.quiz-results__points > span');
            const value = Math.min(10, Math.max(0, data.points[type]));

            items.forEach((item, i) => {
              if (i < value) {
                item.classList.add('fill');
              }
            });
          });
        } else {
          setTimeout(() => {
            const quizResult = this.querySelector('#quiz-result-product');
            if (quizResult !== null) {
              quizResult.innerHTML = spinner();
            }
          }, 400);

          this.querySelectorAll('.quiz-results__points > span').forEach((item) => {
            item.classList.remove('fill');
          });

          const buttonsWrapper = document.querySelector('.quiz-results__buttons-wrapper');
          if (buttonsWrapper !== null) {
            buttonsWrapper.style.display = 'none';
          }
        }
      }
    }
    if (!window.customElements.get('quiz-results')) {
      window.customElements.define('quiz-results', QuizResults);
    }

    class QuizModal extends HTMLElement {
      constructor() {
        super();

        this.buttons = document.querySelectorAll('.quiz-results__email-button');
      }

      connectedCallback() {
        this.buttons.forEach((button) => {
          button.addEventListener('click', this._open.bind(this));
        });
        this.querySelector('.quiz-modal__box-close').addEventListener('click', this._close.bind(this));
        window.addEventListener('keyup', (e) => {
          if (e.code === 'Escape') {
            this._close(e);
          }
        });
        document.addEventListener('click', (e) => {
          if (e.target.classList.contains('quiz-modal') || e.target.classList.contains('quiz-modal__box-close')) {
            this._close(e);
          }
        });
        this.querySelector('form').addEventListener('submit', this._submit.bind(this));
        this.querySelector('#quiz-modal-email').addEventListener('keyup', this._emailKeyup.bind(this));
        this.querySelector('#quiz-modal-phone-number').addEventListener('keyup', this._phoneKeyup.bind(this));
      }

      _open(e) {
        e.preventDefault();
        document.body.classList.add('quiz-modal--opened');
      }

      _close(e) {
        e.preventDefault();
        document.body.classList.remove('quiz-modal--opened');
      }

      _submit(e) {
        e.preventDefault();

        const form = e.target;
        const email = form.querySelector('#quiz-modal-email').value;
        const phone = form.querySelector('#quiz-modal-phone-number').value.replace(/[^0-9]/, '');
        const listIDs = form.querySelector('#quiz-modal-list-id').value.split(',');

        if (typeof insiderSendQuizForm === 'function') {
          form.classList.remove('sent');
          form.classList.add('sending');

          const attributes = quizResult || null;

          document.querySelectorAll('[data-question]:checked').forEach((el) => {
            if (typeof attributes[el.dataset.question] === 'undefined') {
              attributes[el.dataset.question] = [];
            }

            attributes[el.dataset.question].push(el.dataset.answer);
          });

          insiderSendQuizForm({ email, phone }, listIDs, attributes);

          setTimeout(function () {
            form.classList.remove('sending');
            form.classList.add('sent');
          }, 2000);
        }
      }

      _emailKeyup(e) {
        e.preventDefault();

        const input = e.target;
        const phone = document.querySelector('#quiz-modal-phone-number');
        const button = document.querySelector('#quiz-modal-button');

        if (input.value.isValidEmail() && phone.value.length === 19) {
          if (button) {
            button.disabled = false;
          }
        } else {
          if (button) {
            button.disabled = true;
          }
        }
      }
      _phoneKeyup(e) {
        const email = document.querySelector('#quiz-modal-email');
        const button = document.querySelector('#quiz-modal-button');

        formatPhoneNumber(e);

        if (email.value.isValidEmail() && e.currentTarget.value.length === 19) {
          if (button) {
            button.disabled = false;
          }
        } else {
          if (button) {
            button.disabled = true;
          }
        }
      }
    }
    if (!window.customElements.get('quiz-modal')) {
      window.customElements.define('quiz-modal', QuizModal);
    }
  } catch (err) {
    console.error(err);
  }
})(window);
